import { InfoIcon } from '@/components/ui/icons/icons-new'
import { type PlatformType } from '@backend/lib/db/schema/platform'

interface ValidationWarning {
  platform: PlatformType
  message: string
}

interface Props {
  warnings: ValidationWarning[]
}

export const WorkspacePreviewValidation = ({ warnings }: Props) => {
  if (warnings.length === 0) return null

  return (
    <div className="mx-auto w-full max-w-[450px]">
      <div className="space-y-1">
        {warnings.map((warning, index) => (
          <div
            key={index}
            className="bg-card border-border flex items-center gap-2 rounded-lg border p-2">
            <span className="mr-2 shrink-0 rounded-full bg-amber-400 p-1">
              <InfoIcon width={12} height={12} color="black" />
            </span>
            <p className="text-xs">{warning.message}</p>
          </div>
        ))}
      </div>
    </div>
  )
}
